import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { DailyDosingTableResponse } from '../interfaces/daily-dosing';

@Injectable({
    providedIn: 'root',
})

export class DailyDosingService {
    baseUrl = environment.baseUrl;
    constructor(private http: HttpClient) { }

    getDailyDosingData(siteId: number, tankId: number): Observable<DailyDosingTableResponse[]> {
        var params = new URLSearchParams();
        params.append('siteId', siteId.toString());
        params.append('tankId', tankId.toString());
        var url = `${this.baseUrl}dailydosing?${params.toString()}`;
        return this.http.get<DailyDosingTableResponse[]>(url);
    }

    addSalisburyDosing(dt: string): Observable<any>{
        const encoded = encodeURIComponent(dt);
        var url = `${this.baseUrl}dailydosing/SetSalisburyDosing?SalisburyDateTime=${encoded}`;
        return this.http.get<any>(url);
    }

    getDailyDosingById(id: number): Observable<any> {
        var url = `${this.baseUrl}dailydosing/${id}`;
        return this.http.get<any>(url);
    }
    getDailyDosingSalisbury(siteId: number): Observable<any> {
        var url = `${this.baseUrl}dailydosing/salisbury?siteId=${siteId}`;
        return this.http.get<any>(url);
    }
    saveDailyDosing(payload: any) {
        var url = `${this.baseUrl}dailydosing`;
        return this.http.post<boolean>(url, payload);
    }
    saveSalisburyDosing(payload: any) {
        var url = `${this.baseUrl}dailydosing/salisbury`;
        return this.http.post<boolean>(url, payload);
    }
    onDelete(id: number) {
        var url = `${this.baseUrl}dailydosing/${id}`;
        return this.http.delete<boolean>(url);
    }
    getWeightedAverageForScratchPad(payload: any) {
        var url = `${this.baseUrl}dailydosing/scratch-pad/get-weighted-average`;
        return this.http.post<any[]>(url, payload);
    }
    saveForScratchPad(payload: any) {
        var url = `${this.baseUrl}dailydosing/scratch-pad/get-weighted-average`;
        return this.http.post<boolean>(url, payload);
    }

    getDailyDosingForScratchPad(id: number): Observable<any[]> {
        var url = `${this.baseUrl}dailydosing/${id}/scratch-pad`;
        return this.http.get<any[]>(url);
    }

}